import React from 'react';
import { Provider } from 'react-redux';
import store from './src/store';
import ThemeWrapper from './theme-wrapper';

// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element }) => {
  if (typeof window !== undefined) {
    // eslint-disable-next-line no-undef
    const userActions = require('./src/actions/userActions');
    store.dispatch(userActions.watchFirebaseAuthState(true));
  }


  return (
    <ThemeWrapper>
      <Provider store={store}>{element}</Provider>
    </ThemeWrapper>
  );
};
